module.exports = __webpack_public_path__ + "images/power-default.fef99c3e16f565d26e2fc8e9a8d272fd.png";